import { IAPIRoutes } from "../../../../config";
import { getDevicelessApiEndpoint } from "../../../../util/devicelessRouting";

export const PsnAlertRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getPsnAlertList: IGetPsnAlertListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetDashboardList.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getPsnAlertGraphDataList: IGetPsnAlertGraphDataListAPI = async (
    payload
  ) =>
    GET(
      APIRoutes.apiGetPsnAlertGraphDataList.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getPsnAlertAckAPI: IGetPSNAckAPI = async (payload) =>
    GET(
      APIRoutes.apiGetPSNAck
        .replace("{clinic_id}", payload.clinicId?.toString())
        .replace("{alert_id}", payload.alertId),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const addPsnAlertAckAPI: IAddPSNAckAPI = async (payload) => {
    const endpoint = getDevicelessApiEndpoint(APIRoutes.apiAddPSNAck);
    return PUT(
      endpoint
        .replace("{clinic_id}", payload.clinic_id?.toString())
        .replace("{alert_id}", payload.alert_id),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const putPSNv2ReviewAPI: IPutPSNv2ReviewAPI = async (payload) =>
    PUT(
      APIRoutes.apiPutPSNAcknowledge
        .replace("{clinic_id}", payload.clinic_id?.toString())
        .replace("{notification_uuid}", payload.notification_uuid),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getPsnAlertList,
    getPsnAlertGraphDataList,
    getPsnAlertAckAPI,
    addPsnAlertAckAPI,
    putPSNv2ReviewAPI,
  };
};
